var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { Color } from '../const/';
import TextField from '../text-field/text-field';
import Icon from '../icon/icon';
var Search = Icon.Search;
function SearchBarStateless(_a) {
    var onSearch = _a.onSearch, props = __rest(_a, ["onSearch"]);
    var isDisabled = props.isDisabled, invalidMessage = props.invalidMessage;
    var handleKeyUp = function (e) {
        if (e.keyCode === 13)
            onSearch();
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TextField, __assign({}, props, { onKeyUp: function (e) { return handleKeyUp(e); } })),
        React.createElement(IconArea, { disabled: isDisabled, invalidMessage: invalidMessage, onClick: !isDisabled && !invalidMessage ? onSearch : function () { } },
            React.createElement(Search, null))));
}
var IconArea = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  border: 1px solid\n    ", ";\n  border-radius: 0 4px 4px 0;\n  cursor: pointer;\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  width: 40px;\n\n  > svg {\n    path {\n      color: ", ";\n      fill: currentColor;\n    }\n  }\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  border: 1px solid\n    ",
    ";\n  border-radius: 0 4px 4px 0;\n  cursor: pointer;\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  width: 40px;\n\n  > svg {\n    path {\n      color: ",
    ";\n      fill: currentColor;\n    }\n  }\n\n  &:hover {\n    background: ", ";\n  }\n"])), Color.VERY_LIGHT_GRAY_6, function (props) {
    return props.disabled
        ? Color.VERY_LIGHT_GRAY_2
        : props.invalidMessage
            ? Color.SOFT_RED
            : Color.LIGHT_GRAY_2;
}, function (props) {
    return props.disabled ? Color.LIGHT_GRAY_3 : Color.DARK_GRAY_2;
}, Color.WHITE);
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n\n  input {\n    border-radius: 4px 0 0 4px;\n    border-right: none;\n  }\n"], ["\n  display: flex;\n\n  input {\n    border-radius: 4px 0 0 4px;\n    border-right: none;\n  }\n"])));
export default SearchBarStateless;
var templateObject_1, templateObject_2;
//# sourceMappingURL=searchbar.js.map